import { render, staticRenderFns } from "./CodingRuleList.vue?vue&type=template&id=39266a20&scoped=true"
import script from "./CodingRuleList.vue?vue&type=script&lang=js"
export * from "./CodingRuleList.vue?vue&type=script&lang=js"
import style0 from "./CodingRuleList.vue?vue&type=style&index=0&id=39266a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39266a20",
  null
  
)

export default component.exports